<template>
  <div>
    <vue-dropzone
      id="dropzone"
      ref="myVueDropzone"
      :options="dropzoneOptions"
      @vdropzone-file-added="fileAdded"
      @vdropzone-success="uploadSuccess"
      @vdropzone-error="uploadError"
    ></vue-dropzone>
  </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';

export default {
  components: {
    vueDropzone: vue2Dropzone,
  },

  props: {
    storeAnswerRoute: {
      type: String,
      required: true,
    },
    maxFiles: {
      type: Number,
      required: true,
      coerce: (str) => parseInt(str),
    },
    question: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      dropzoneOptions: {
        url: this.storeAnswerRoute,
        addRemoveLinks: false,
        paramName: this.question.slug + '[value][0][document]',
        maxFiles: parseInt(this.maxFiles),
        maxFilesize: 12,
        uploadMultiple: false,
        headers: {
          'X-CSRF-TOKEN': document.head.querySelector('meta[name="csrf-token"]')
            .content,
        },
        dictDefaultMessage:
          "Drop a file here to upload - you'll be able to change its title",
      },
      fileUploadTable: null,
    };
  },

  mounted() {
    this.FileUploadQuestion = new window.Framework.FileUploadQuestion(
      this.question,
      this.storeAnswerRoute
    );
  },

  methods: {
    uploadSuccess(file, response) {
      this.$refs.myVueDropzone.removeFile(file);
      this.FileUploadQuestion.addFileToTable(response);
    },

    uploadError(file, message) {
      this.$refs.myVueDropzone.removeFile(file);
      this.FileUploadQuestion.displayErrorMessage(message);
    },

    fileAdded() {
      this.FileUploadQuestion.hideErrorMessage();
    },
  },
};
</script>
